<div class="share-dialog">

  <h2 class="dialog-title">Share Note</h2>

  <div class="note-preview">
    <p class="note-preview-label">Sharing this note</p>
    <p class="note-preview-text">{{ note.content }}</p>
  </div>

  <ng-container *ngIf="state !== 'success'">
    <p class="confirm-text">Are you sure you want to share this note with the client {{ clientName }}</p>
    <p class="field-error submit-error" *ngIf="state === 'error'">{{ errorMessage }}</p>
  </ng-container>

  <div class="success-state" *ngIf="state === 'success'">
    <i class="fa fa-check-circle" aria-hidden="true"></i>
    <p>Note shared successfully with {{ clientName }}.</p>
  </div>

  <div class="dialog-actions">
    <button type="button" class="btn-cancel" (click)="close()" [disabled]="state === 'submitting'"
            *ngIf="state !== 'success'">Cancel</button>
    <button type="button" class="btn-save" (click)="share()" [disabled]="state === 'submitting'"
            *ngIf="state !== 'success'">
      {{ state === 'submitting' ? 'Sharing…' : 'Share' }}
    </button>
    <button type="button" class="btn-save" (click)="close()" *ngIf="state === 'success'">Done</button>
  </div>

</div>